/**
 * Copyright 2023 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { Modal, Text, View } from '@az/starc-ui'
import moment from 'moment'
import { FC, useMemo } from 'react'
import { Input } from '../Input'

interface Props {
  type: 'prompt' | 'expired'
  open: boolean
  timeLeft: number
  onClose: () => void
  onContinueClick: () => void
}

export const IdleTimeoutModal: FC<Props> = ({ open, type, onContinueClick, onClose, timeLeft }) => {
  const time = useMemo(() => {
    if (!open) return ''

    return moment.utc(timeLeft * 1000).format('m:ss')
  }, [open, timeLeft])

  return (
    <Modal open={open} onClose={onClose} size={'small'} closeByClickAway={false}>
      <View gap={2}>
        <View padding={[4, 0]}>
          <Text variant="display-3">Session {type == 'expired' ? 'Expired' : 'Expiration'}</Text>
        </View>
        {type == 'expired' ? (
          <Text>Your session has expired.</Text>
        ) : (
          <Text>Your session is about to expire due to inactivity</Text>
        )}
        {type == 'expired' ? (
          <Text>You will be logged out</Text>
        ) : (
          <View direction="row" gap={1}>
            <Text>Time remaining: </Text>
            <Text weight="bold">{time}</Text>
          </View>
        )}
        <Input.Submit.Area>
          <Input.Submit onClick={onContinueClick}>
            {type == 'expired' ? 'Ok' : 'Continue session'}
          </Input.Submit>
        </Input.Submit.Area>
      </View>
    </Modal>
  )
}
